import { all, put, call, select, takeEvery } from 'redux-saga/effects'
import { getLeftMenuData } from 'services/menu'
import UserActions from '../user/actions'
import { menuSetState } from '../actions'

const getUser = (state) => state.user
export function* GET_DATA() {
  const role = yield select(getUser)
  let menuLeftData = yield call(getLeftMenuData, role)
  menuLeftData = menuLeftData.filter((datum) => datum.display !== false)
  yield put(menuSetState({ menuLeftData }))
  // yield put({
  //   type: 'menu/SET_STATE',
  //   payload: {
  //     menuLeftData,
  //   },
  // })
}

export default function* rootSaga() {
  yield all([
    takeEvery(UserActions.LOGIN, GET_DATA),
    takeEvery(UserActions.LOAD_CURRENT_ACCOUNT, GET_DATA),
    GET_DATA(), // run once on app load to fetch menu data
  ])
}
